import { render, staticRenderFns } from "./wallet-guide.vue?vue&type=template&id=0745f42b&scoped=true&"
import script from "./wallet-guide.vue?vue&type=script&setup=true&lang=ts&"
export * from "./wallet-guide.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./wallet-guide.vue?vue&type=style&index=0&id=0745f42b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0745f42b",
  null
  
)

export default component.exports